import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import UserRoute from 'components/common/UserRoute';
import Spinner from 'components/common/Spinner';
import { getPhotoReportSettings } from 'actions/asyncActions';

@connect(state => ({
    settings: getPhotoReportSettings.selectData(state),
    meta: getPhotoReportSettings.selectMeta(state),
}))
export default class PhotoReportsRoute extends Component {
    render() {
        const { settings, meta, ...rest } = this.props;

        if (!meta.success && !meta.error) {
            return <Spinner />;
        }

        if (!settings || !settings.enabled) {
            return <Redirect to='/' />;
        }

        return <UserRoute {...rest} />;
    }
}
